export default __webpack_public_path__ + "accordionDownArrow.da3a0920.svg";